import { useAuthContext } from '../../adminlogin/useAuthContext';
import { useReligionContext } from "./useReligionContext";
import API_URL from '../../api/APIUrl';

const ReligionRow = ({id,title}) => {
    const {dispatch} = useReligionContext();
    const {adminuser} = useAuthContext();

    const handleClick = async () =>{

        if(!adminuser) {
            return;
        }

        const response = await fetch(API_URL.DELETE_SINGLE_RELIGION + id,{
            method:'DELETE',
            headers:{
                'Authorization': `Bearer ${adminuser.token}` 
            }
        });
        const json = await response.json();
        console.log(json);
        if(response.ok){
            dispatch({type:'DELETE_RELIGION',payload:json});
        }
    }
    
    return (
        <tr key={id}>
            <th scope="row">{id}</th>
            <td>{title}</td>
            <td><span onClick={handleClick}>Delete</span></td>
        </tr>
    )
}

export default ReligionRow;